'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="en">
      <body
        // biome-ignore lint/plugin: global-error renders outside the MUI ThemeProvider, so the theme cannot style it
        style={{ fontFamily: 'Arial, sans-serif', padding: '2rem' }}
      >
        <h2>Something went wrong</h2>
        <p>Please try refreshing the page.</p>
        {error?.digest ? <p>Error reference: {error.digest}</p> : null}
        <button type="button" onClick={() => reset()}>
          Try again
        </button>
      </body>
    </html>
  )
}
